import { BlockBlobClient } from '@azure/storage-blob';
import { reportErrorToServer } from '../services/error-logger';
import apiClient from './api-client';
const getSASTokenUrl = async (financingProgramId, creditApplicationId, data, recaptcha) => {
    const payload = {
        method: 'POST',
        url: `${financingProgramId}/creditApplication/${creditApplicationId}/GenerateSASTokenUrl`,
        data,
        headers: {
            'x-recaptcha-token': recaptcha,
        },
    };
    const response = await apiClient.request(payload);
    return response.data;
};
const convertStringToArrayBuffer = (str) => {
    const textEncoder = new TextEncoder();
    return textEncoder.encode(str).buffer;
};
function convertFileToArrayBuffer(file) {
    return new Promise((resolve, reject) => {
        if (!file?.name) {
            reject(new Error('Invalid or missing file.'));
        }
        const reader = new FileReader();
        reader.onload = () => {
            const arrayBuffer = reader.result;
            if (arrayBuffer === null) {
                resolve(null);
                return;
            }
            if (typeof arrayBuffer === 'string') {
                resolve(convertStringToArrayBuffer(arrayBuffer));
                return;
            }
            if (!arrayBuffer) {
                reject(new Error('Failed to read file into ArrayBuffer.'));
                return;
            }
            resolve(arrayBuffer);
        };
        reader.onerror = () => {
            reject(new Error('Error reading file.'));
        };
        reader.readAsArrayBuffer(file);
    });
}
export const uploadFiles = async (financingProgramId, dto) => {
    const sasDto = {
        applicantType: dto.applicantType,
        subKey: dto.subKey,
        typeId: dto.typeId,
        fileSASTokenUrls: {},
    };
    dto.files.forEach((file, index) => {
        sasDto.fileSASTokenUrls[`${index}-${file.name}`] = '';
    });
    const sasTokens = await getSASTokenUrl(financingProgramId, dto.creditApplicationId, sasDto, dto.recaptcha);
    try {
        await Promise.all(dto.files.map(async (file, index) => {
            const fileArrayBuffer = await convertFileToArrayBuffer(file);
            if (fileArrayBuffer === null || fileArrayBuffer.byteLength < 1) {
                return;
            }
            const concernedSASUrl = sasTokens.fileSASTokenUrls[`${index}-${file.name}`];
            const blockBlobClient = new BlockBlobClient(concernedSASUrl);
            await blockBlobClient.uploadData(fileArrayBuffer);
        }));
    }
    catch (error) {
        reportErrorToServer(error, {
            creditApplicationId: dto.creditApplicationId,
            fileCount: dto.files.length,
        });
        throw error;
    }
    return {
        creditApplicationId: dto.creditApplicationId,
        applicantType: dto.applicantType,
        typeId: dto.typeId,
        subKey: dto.subKey,
        status: sasTokens.status,
    };
};
